import loggerService from '../../../utils/loggerService';

export const getInjector = async () => {
  try {
    await window.APP_EXTENSION_SDK_ANGULAR_JS_LOADED;
  } catch (error) {
    loggerService.error(
      new Error('Error waiting for APP_EXTENSION_SDK_ANGULAR_JS_LOADED'),
      { context: { error } },
    );

    return undefined;
  }

  return window.angular.element(document.body)?.injector();
};
